<template>
    <collapsable :default-closed="true">
        <template #toggler>
            <h3 class="flex items-center gap-2 text-xl !leading-[20px] !font-bold">
                {{ trans('activities.overview.header') }} <spinner v-if="!workorderHistory" />
            </h3>
        </template>
        <div v-if="workorderHistory && workorderHistory.length" class="grid gap-x-4 text-sm md:grid-cols-[auto_1fr] md:gap-y-1">
            <template v-for="(entry, idx) in workorderHistory">
                <div class="flex items-start gap-1">
                    <b>{{ formatDate(entry.date) }}</b>
                    <span v-if="idx + 1 < workorderHistory.length" class="text-muted">({{ diffToPreviousEntry(entry, idx) }})</span>
                </div>
                <div class="mb-4 md:!mb-0">{{ entry.description }}</div>
            </template>
        </div>
        <div v-else>-</div>
    </collapsable>
</template>
<script setup>
import { DateTime } from 'luxon';
import { trans } from '@/mixins/i18n.js';
import Collapsable from '@/Components/Collapsable.vue';
import Spinner from '@/Components/Spinner.vue';

const props = defineProps({
    workorderHistory: Array,
});

function formatDate(dateString) {
    if (!dateString) return;
    return DateTime.fromISO(dateString).toFormat('yyyy-MM-dd hh:mm a');
}

function diffToPreviousEntry(entry, index) {
    const previousEntry = props.workorderHistory[index + 1];
    if (!previousEntry) return '';
    const currentDate = DateTime.fromISO(entry.date);
    const previousDate = DateTime.fromISO(previousEntry.date);

    // Use Luxon Duration from DateTime.diff and shiftTo for normalized units
    const duration =
        currentDate >= previousDate
            ? currentDate.diff(previousDate, ['days', 'hours', 'minutes']).shiftTo('days', 'hours', 'minutes')
            : previousDate.diff(currentDate, ['days', 'hours', 'minutes']).shiftTo('days', 'hours', 'minutes');

    const { days = 0, hours = 0, minutes = 0 } = duration.toObject();
    const d = Math.trunc(days);
    const h = Math.trunc(hours);
    const m = Math.trunc(minutes);

    const parts = [];
    if (d > 0) parts.push(`${d}d`);
    if (h > 0) parts.push(`${h}h`);
    if (m > 0) {
        if (h > 0 || d > 0) {
            parts.push(`${String(m).padStart(2, '0')}m`);
        } else {
            parts.push(`${m}m`);
        }
    }

    if (parts.length === 0) return '0m';
    return parts.join(' ');
}
</script>
